import Fab from "@mui/material/Fab";
import { PropTypes } from "prop-types";

const ButtonOk = (props) => {
  return (
    <Fab
      sx={{ width: 100 }}
      variant="extended"
      color="primary"
      onClick={props.handleClick}
    >
      ΟΚ
    </Fab>
  );
};

export default ButtonOk;

ButtonOk.propTypes = {
  handleClick: PropTypes.func.isRequired,
};
